export const appName = 'sendlist';

export const SHORT_ID_DID_NOT_RESOLVE = 'Short ID did not resolve';
